
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Wenn der Leidensdruck infolge eines Schlafproblems die Lebensbewältigung erschwert oder wenn eine Schlafstörung mit negativen gesundheitlichen Konsequenzen einhergeht, ist das ein medizinisch relevantes Problem. `}<M mdxType="M">{`Als chronische Schlaflosigkeit oder Insomnie wird eine Einschlaf- oder Durchschlafstörung bezeichnet, die mindestens an drei Tagen der Woche während mindestens drei Monaten besteht.`}</M></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;